/**
 * Shared "Added to Cart" success modal.
 * Provides window.showAddToCartModal(productData) for any add-to-cart flow.
 */
(function () {
  const modal = document.getElementById('add-to-cart-modal');
  if (!modal) return;

  const els = {
    image: modal.querySelector('.add-to-cart-modal__image'),
    subtitle: modal.querySelector('.add-to-cart-modal__subtitle'),
    title: modal.querySelector('.add-to-cart-modal__product-title'),
    players: modal.querySelector('.add-to-cart-modal__players'),
    comparePrice: modal.querySelector('.add-to-cart-modal__compare-price'),
    price: modal.querySelector('.add-to-cart-modal__price'),
  };

  /**
   * Format cents into a money string using Shopify's money_format.
   * @param {number} cents
   * @returns {string}
   */
  function formatMoney(cents) {
    const format = window.Shopify?.money_format || '${{amount}}';
    return format
      .replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
      .replace(
        /\{\{\s*amount_with_comma_separator\s*\}\}/,
        (cents / 100).toFixed(2).replace('.', ',')
      );
  }

  /**
   * Show the success modal with product data.
   * @param {object} data
   * @param {string|null} data.image - Product image URL
   * @param {string|null} data.subtitle - Product subtitle (metafield, optional)
   * @param {string} data.title - Product title
   * @param {string|null} data.players - Player names (metafield, optional)
   * @param {number} data.compareAtPrice - Compare-at price in cents (0 if none)
   * @param {number} data.price - Price in cents
   */
  window.showAddToCartModal = function (data) {
    if (!modal) return;

    // Image
    if (data.image) {
      els.image.src = data.image;
      els.image.alt = data.title || '';
      els.image.style.display = '';
    } else {
      els.image.style.display = 'none';
    }

    // Subtitle
    if (data.subtitle) {
      els.subtitle.textContent = data.subtitle;
      els.subtitle.style.display = '';
    } else {
      els.subtitle.style.display = 'none';
    }

    // Title
    els.title.textContent = data.title || '';

    // Players
    if (data.players) {
      els.players.textContent = data.players;
      els.players.style.display = '';
    } else {
      els.players.style.display = 'none';
    }

    // Compare-at price
    const compareAt = parseInt(data.compareAtPrice) || 0;
    const price = parseInt(data.price) || 0;

    if (compareAt && compareAt > price) {
      els.comparePrice.textContent = formatMoney(compareAt);
      els.comparePrice.style.display = '';
    } else {
      els.comparePrice.textContent = '';
      els.comparePrice.style.display = 'none';
    }

    // Price
    els.price.textContent = formatMoney(price);

    modal.showModal();
  };

  // Close handlers
  modal.querySelector('.add-to-cart-modal__close')?.addEventListener('click', function () {
    modal.close();
  });

  modal.querySelector('.add-to-cart-modal__button--secondary')?.addEventListener('click', function () {
    modal.close();
  });

  modal.addEventListener('click', function (e) {
    if (e.target === modal) {
      modal.close();
    }
  });

  // AJAX add-to-cart for card gallery forms (event delegation, handles dynamically loaded content)
  document.addEventListener('submit', async function (e) {
    var form = e.target.closest('.card-gallery__cart-form');
    if (!form) return;
    e.preventDefault();

    var button = form.querySelector('.card-gallery__action-button--cart');
    if (!button || button.disabled) return;

    var originalText = button.textContent.trim();
    button.disabled = true;
    button.textContent = 'ADDING...';

    try {
      var formData = new FormData(form);
      var response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'text/html' },
        body: formData,
      });
      var data = await response.json();
      if (!response.ok || data.status) throw new Error(data.message || 'Could not add to cart');

      // Update cart icon without triggering cart drawer
      var cartIcon = document.querySelector('cart-icon');
      if (cartIcon && cartIcon.renderCartBubble) cartIcon.renderCartBubble(1, true, true);

      // Show shared modal
      window.showAddToCartModal({
        image: data.image || form.dataset.productImage || null,
        subtitle: form.dataset.productSubtitle || null,
        title: form.dataset.productTitle || data.product_title || '',
        players: form.dataset.playerNames || null,
        compareAtPrice: parseInt(form.dataset.compareAtPrice) || 0,
        price: parseInt(form.dataset.price) || data.price || 0,
      });
    } catch (err) {
      button.textContent = 'ERROR';
      setTimeout(function () {
        button.textContent = originalText;
        button.disabled = false;
      }, 3000);
      return;
    }

    button.textContent = originalText;
    button.disabled = false;
  });
})();
